import { NEARBY_AIRPORT_PADDING_LEFT } from './flightForm.constants';

/** From/To airport suggestion card — white panel, tight rows (shared by origin and destination). */
export const AIRPORT_SUGGESTION_PAPER_SX = {
  minWidth: 0,
  maxWidth: '100%',
  width: '100%',
  background: '#FFFFFF',
  borderRadius: '16px',
  boxShadow: '0 12px 32px rgba(32, 32, 42, 0.14)',
  border: '1px solid rgba(32, 32, 42, 0.06)',
  p: '12px',
  pb: '10px',
  overflowX: 'hidden',
  overflowY: 'hidden',
  '& .MuiAutocomplete-listbox': {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    p: 0,
    pt: '8px',
    maxHeight: { xs: '40vh', md: '280px' },
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    '&::-webkit-scrollbar': { display: 'none' },
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
  },
  '& .MuiAutocomplete-option': {
    p: '10px 8px !important',
    minHeight: 'auto !important',
    alignItems: 'center !important',
    whiteSpace: 'normal !important',
    overflowX: 'hidden !important',
    width: '100% !important',
    boxSizing: 'border-box !important',
    backgroundColor: 'transparent !important',
    '&:hover': { backgroundColor: '#EDEDF0 !important' },
    '&[aria-selected="true"]': { backgroundColor: 'transparent !important' },
  },
  '& .MuiAutocomplete-option[data-nearest="true"]': {
    p: `10px 8px 10px ${NEARBY_AIRPORT_PADDING_LEFT} !important`,
  },
  '& .MuiAutocomplete-option[data-separator="true"]': {
    backgroundColor: 'transparent !important',
    p: '6px 8px !important',
    minHeight: 'auto !important',
    cursor: 'default !important',
    pointerEvents: 'none !important',
    '&:hover': { backgroundColor: 'transparent !important' },
  },
};

/** Figma 6544:98016 active border #252637 — sx guards against MUI overrides. */
export const MOBILE_AIRPORT_SHEET_FIELD_SX = (isActive) => ({
  height: '56px',
  minHeight: '56px',
  maxHeight: '56px',
  px: '16px',
  py: '8px',
  borderRadius: '8px',
  bgcolor: '#f3f3f7',
  border: isActive ? '1px solid #252637' : '1px solid transparent',
  boxSizing: 'border-box',
  outline: 'none',
  boxShadow: 'none',
  WebkitTapHighlightColor: 'transparent',
  '&:focus-within': {
    border: isActive ? '1px solid #252637' : '1px solid transparent',
    outline: 'none',
    boxShadow: 'none',
  },
});
